export default "__VITE_ASSET__DFXpBXaR__"